











































import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import GCompetencyDistribution from '@/components/GCompetencyDistribution.vue';
import { Component } from 'vue-property-decorator';
import { BreadCrumbElement } from '@/models/bread-crumb-element';
import GTitleBar from '@/components/GTitleBar.vue';
import { studentModule } from '@/store/modules/entities/student.module';
import { masterModule } from '@/store/modules/entities/master.module';
import GTopicSubject from '@/components/GTopicSubject.vue';
import GCustomBreadCrumb from '@/components/GCustomBreadCrumb.vue';
import GStudentRecordScoreComparison from '@/views/GStudentRecord/GStudentRecordScoreComparison.vue';
import GStudentRecordItemCell from '@/views/GStudentRecord/GStudentRecordItemCell.vue';
import GStudentRecordValueCell from '@/views/GStudentRecord/GStudentRecordValueCell.vue';
import GSubTitleBar from '@/components/GSubTitleBar.vue';
import GStudentRecordProfile from '@/views/GStudentRecord/GStudentRecordProfile.vue';
import GStudentRecordGrowth from '@/views/GStudentRecord/GStudentRecordGrowth.vue';
import GStudentRecordGrowthAdvice from '@/views/GStudentRecord/GStudentRecordGrowthAdvice.vue';
import GStudentRecordCompetencySummary from '@/views/GStudentRecord/GStudentRecordCompetencySummary.vue';
import GStudentRecordFindingsProposals from '@/views/GStudentRecord/GStudentRecordFindingsProposals.vue';
import GStudentRecordTrends from '@/views/GStudentRecord/GStudentRecordTrends.vue';
import GStudentRecordRecommendationLetter from '@/views/GStudentRecord/GStudentRecordRecommendationLetter.vue';

import GStudentRecordInterviewNavi from '@/views/GStudentRecord/GStudentRecordInterviewNavi.vue';
import { GEnum } from '@/constants/enum.defination';
import { GetStudentRequest } from '@/models/student/get-student-request';
import { studentAllCompetencyModule } from '@/store/modules/frames/student-all-competency.module';
import { Student } from '@/models/student/student';
import { StudentKartePrevNext } from '@/models/student/student';

@Component({
  name: 'GStudentRecord',
  components: {
    GStudentRecordProfile,
    GStudentRecordGrowth,
    GStudentRecordGrowthAdvice,
    GStudentRecordCompetencySummary,
    GStudentRecordFindingsProposals,
    GStudentRecordTrends,
    GSubTitleBar,
    GStudentRecordValueCell,
    GStudentRecordItemCell,
    GStudentRecordScoreComparison,
    GCustomBreadCrumb,
    GTopicSubject,
    GTitleBar,
    GCompetencyDistribution,
    GStudentRecordInterviewNavi,
    GStudentRecordRecommendationLetter,
  },
  computed: {},
})
export default class GStudentRecord extends mixins(GPageBase) {
  breadCrumbItems: BreadCrumbElement[] = [];
  studentID: number = 0;
  lazy: boolean = false;
  currentTab: number = GEnum.KarteTab.TabProfile;
  referrer: string = '';

  beforeRouteEnter(to: any, from: any, next: any) {
    studentModule.setStudentKarteReferrer(from.name);
    next();
  }

  async created() {
    this.studentID = parseInt(this.$route.params.studentID);
  }

  async mounted() {
    // パンくずが studentModule.getStudent() の後だと、領域が存在したりしなかったりで画面がズレるので先に空の状態で配置
    this.breadCrumbItems = [{ title: this.$t('HOME').toString(), icon: 'ios-home', routerPath: '/pages/home' }];
    studentModule.clean();
    await studentModule.getStudent({ studentID: this.studentID } as GetStudentRequest);
    // student を取得し終わった後にパンくずに生徒名を追加
    this.breadCrumbItems.push({ title: this.fullName });

    // 推薦書作成のアイコンを設定
    // NOTE:Vue UIに存在しないアイコンのため、独自に作成
    this.addCustomIcon();

    if (studentModule.studentKarteReferrer !== 'exam-detail' && studentModule.studentKarteReferrer != null) {
      await studentModule.fetchStudentKartePrevNext(this.studentID);
    }
    await studentModule.fetchStudentCompetencyData(this.studentID).then(() => {
      this.lazy = true;
    });
    masterModule.fetchInterviewNaviCompetencies();

    await studentAllCompetencyModule.fetchstudentCompetencyGrowth(this.studentID);
    if (this.$route.params.tab) {
      const tab = parseInt(this.$route.params.tab);
      const tabElements = document.querySelectorAll('.ivu-tabs-tab');
      if (tabElements[tab]) (tabElements[tab] as HTMLElement).click();
    }
  }

  get isKarteTabProfile(): boolean {
    return this.currentTab === GEnum.KarteTab.TabProfile;
  }
  get isKarteTabGrowth(): boolean {
    return this.currentTab === GEnum.KarteTab.TabGrowth;
  }
  get isKarteTabInterviewNavi(): boolean {
    return this.currentTab === GEnum.KarteTab.TabInterviewNavi;
  }
  get isKarteTabCompetencySummary(): boolean {
    return this.currentTab === GEnum.KarteTab.TabCompetencySummary;
  }
  get isKarteTabFindingsProposals(): boolean {
    return this.currentTab === GEnum.KarteTab.TabFindingsProposals;
  }
  get isKarteTabTrends(): boolean {
    return this.currentTab === GEnum.KarteTab.TabTrends;
  }
  get isKarteTabRecommendationLetter(): boolean {
    return this.currentTab === GEnum.KarteTab.TabRecommendationLetter;
  }

  get isDispCtrlTypeUchida(): boolean {
    return this.$store.state.account.dispCtrlType === GEnum.DispCtrlType.Uchida;
  }

  get student(): Student {
    return studentModule.student;
  }

  get fullName(): string {
    return studentModule.student.fullName;
  }

  get prevNextStudent(): StudentKartePrevNext {
    return studentModule.kartePrevNext;
  }

  get hasPrevNext(): boolean {
    return studentModule.kartePrevNext.hasPrevnext;
  }

  goToHome() {
    this.$router.push({ name: 'home' });
  }

  goToPrev() {
    this.$router.replace({ path: `/pages/student-record/${this.prevNextStudent.prev.studentID}` });
  }

  goToNext() {
    this.$router.replace({ path: `/pages/student-record/${this.prevNextStudent.next.studentID}` });
  }

  handleSelectedTab(tabNum: number) {
    this.currentTab = tabNum;
  }

  addCustomIcon() {
    const tab = Array.from<HTMLElement>(document.querySelectorAll('.ivu-tabs-tab')).find(t => t.innerText === this.$t('RECOMMENDATION_LETTER'));
    if (tab) {
      const iconElement = document.createElement('i');
      iconElement.classList.add('ivu-icon', 'ivu-icon-custom-recommendation');

      tab.insertBefore(iconElement, tab.firstChild);
    }
  }

  get isRecommendationLetterAvailable(): boolean {
    return this.hasCompetencyData && this.isJapaneseLanguage;
  }

  get hasCompetencyData(): boolean {
    // コンピテンシーデータの有無を判定
    // api/v3/academic/students/{studentID}/competencyの結果をチェック
    const competencyData = studentModule.studentCompetencyData;

    // competencies配列の長さが0の場合に「存在しない」と判定
    const hasData = competencyData && competencyData.competencyComparisons.length > 0;

    return !!hasData;
  }

  get isJapaneseLanguage(): boolean {
    const langCode = this.$store.state.currentLanguage && this.$store.state.currentLanguage.langCode;
    return langCode === 'ja';
  }
}
